import requestProvider from "./axiosHandler";

const getRelevantPersonByCustomer = (id) => {

    return requestProvider
        .get(`/relevant-person/get-by-customer/${id}`)
}

const createRelevantPerson = (list) => {

    return requestProvider
        .post('/relevant-person', list)
}

const updateRelevantPerson = (list) => {

    return requestProvider
        .put('/relevant-person', list)
}

const deleteRelevantPerson = (id) => {

    return requestProvider
        .delete(`/relevant-person/${id}`)
}

const getRelevantPersonById = (id) => {

    return requestProvider
        .get(`/relevant-person/${id}`)
}

export {createRelevantPerson, getRelevantPersonByCustomer, getRelevantPersonById, updateRelevantPerson, deleteRelevantPerson}